import { useQuery } from "@tanstack/react-query";
import { BasePreference } from "../../types/preference";
import { meKeys } from "./meKeys";
import { meService } from "./meService";

const myPreferences: BasePreference[] = [];
const myPreferenceFetcher = () => meService.preferences().then((r) => r.data.data);
export const useMyPreferencesQuery = () => {
	const { data, isLoading } = useQuery({ queryKey: meKeys.preferences, queryFn: myPreferenceFetcher });

	return {
		data: data || myPreferences,
		isLoading,
	};
};
